import {Injectable} from '@angular/core';
import {environment} from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  IdVerificationRequest,
  MemberVerificationResponse
} from '../../other/components/dialogs/adhoc-id-verification-dialog/adhoc-id-verification-dialog.component';
import {
  BankVerificationRequest,
  BankVerificationResponse,
} from '../../common/models/ExternalMemberVerificationDTO';


const verificationRelativePath = '/member/verification';

@Injectable({
  providedIn: 'root'
})
export class MemberVerificationService {
  private baseIgnUrl = environment.baseIgnUrl;

  constructor(private httpClient: HttpClient) {

  }

  memberVerificationByID(payload: IdVerificationRequest): Observable<MemberVerificationResponse> {
    return this.httpClient.post<MemberVerificationResponse>(this.baseIgnUrl + verificationRelativePath + '/id', payload);
  }

  memberVerificationByIDV2(idNumber: string): Observable<MemberVerificationResponse> {
    return this.httpClient.get<MemberVerificationResponse>(`${this.baseIgnUrl}/v2${verificationRelativePath}/id?idNumber=${idNumber}`);
  }

  bankVerification(payload: BankVerificationRequest): Observable<BankVerificationResponse> {
    return this.httpClient.post<BankVerificationResponse>(this.baseIgnUrl + verificationRelativePath + '/bank', payload);
  }

}
